import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { invalidateAll } from '../../api/queryClient';
import { trpc, type RouterOutputs } from '../../api/trpc';

export type SelfserviceOverview = RouterOutputs['selfservice']['overview'];
export type SelfserviceToken = RouterOutputs['selfservice']['listLinks']['items'][number];
export type SelfSubmission = RouterOutputs['selfservice']['listSubmissions']['items'][number];
/** One generated link — the url carries the one-time secret, shown exactly once. */
export type GeneratedLink = RouterOutputs['selfservice']['createLinks']['links'][number];

export function useSelfserviceOverview(enabled = true) {
  return useQuery(trpc.selfservice.overview.queryOptions(undefined, { enabled }));
}

export function useSelfserviceTokens(limit = 50) {
  return useInfiniteQuery(
    trpc.selfservice.listLinks.infiniteQueryOptions({ limit }, { getNextPageParam: (last) => last.nextCursor }),
  );
}

export function useSelfSubmissions(limit = 50) {
  return useInfiniteQuery(
    trpc.selfservice.listSubmissions.infiniteQueryOptions({ limit }, { getNextPageParam: (last) => last.nextCursor }),
  );
}

export function invalidateSelfservice(): Promise<void> {
  return invalidateAll(trpc.selfservice.pathFilter());
}
